// D-0097 (Rafael 24/10): tela de Detalhe da previsão de pagamento (um plano/OPF do Custo
// Previsto — abas Planos de Pagamento e Aprovados pelo Financeiro). Helpers puros da tela.

export const rotaDetalhePrevisao = (id) => '/financeiroPrevisaoDetalhe/' + id;

// Itens do plano a partir dos cards de /orcamento/{id}/pagamentoFornecedores ("Ver itens", D-0026).
// Plano sem fornecedor ("a definir") virou um card por grupo (`_a_definir:{grupo}`): junta todos.
// Plano "a definir" já VINCULADO a um fornecedor (LINK: `fornecedor_id` nulo e `fornecedor_definido`)
// não tem card próprio: está no card do fornecedor, em `planos_vinculados`.
export function itensDoPlano(cards, plano) {
    const lista = Array.isArray(cards) ? cards : [];
    if (!plano) return [];
    const forn = plano.fornecedor_id === null || plano.fornecedor_id === undefined || plano.fornecedor_id === ''
        ? null : String(plano.fornecedor_id);
    let meus;
    if (forn) {
        meus = lista.filter((c) => String(c.fornecedor_id) === forn);
    } else if (plano.fornecedor_definido) {
        meus = lista.filter((c) => (Array.isArray(c.planos_vinculados) ? c.planos_vinculados : [])
            .some((v) => String(v.id) === String(plano.id)));
    } else {
        meus = lista.filter((c) => String(c.fornecedor_id || '').indexOf('_a_definir') === 0);
    }
    return meus.reduce((acc, c) => acc.concat(Array.isArray(c.itens) ? c.itens : []), []);
}

// Situação para o KPI: { texto, tom, sub }.
export function situacaoPlano(p) {
    if (!p) return { texto: '—', tom: '', sub: '' };
    if (p.status === 'aprovado') return { texto: 'Aprovado pelo Financeiro', tom: 'is-ok', sub: 'Aba Aprovados pelo Financeiro' };
    if (p.status === 'reprovado') return { texto: 'Reprovado', tom: 'is-danger', sub: p.motivo_reprovacao || 'Devolvido ao operador' };
    if (p.status === 'enviado') return { texto: 'Aguardando análise', tom: 'is-warn', sub: 'Aba Planos de Pagamento' };
    return { texto: p.status || '—', tom: '', sub: '' };
}

// Situação da NF do plano: { texto, tom, sub }.
export function situacaoNfPlano(p, formatarData = (d) => d) {
    if (!p) return { texto: '—', tom: '', sub: '' };
    const nfs = Array.isArray(p.nfs) ? p.nfs : [];
    if (p.nf_vinculada) {
        const ref = [p.tipo_documento ? String(p.tipo_documento).toUpperCase() : null, p.numero_referencia ? 'nº ' + p.numero_referencia : null].filter(Boolean).join(' ');
        return { texto: 'NF vinculada', tom: 'is-ok', sub: ref || (nfs.length ? nfs.length + (nfs.length === 1 ? ' nota' : ' notas') : '') };
    }
    if (nfs.length > 0) return { texto: nfs.length + (nfs.length === 1 ? ' nota anexada' : ' notas anexadas'), tom: 'is-ok', sub: 'Ainda não vinculada ao plano' };
    if (p.nf_solicitada_em) return { texto: 'Aguardando NF', tom: 'is-warn', sub: 'Solicitada em ' + formatarData(p.nf_solicitada_em) };
    return { texto: 'Sem NF', tom: '', sub: 'Nenhuma nota anexada' };
}
